import React from 'react';

const SmartVouchersHeader = () => {
  return (
    <div className="text-center max-w-5xl mx-auto space-y-3 px-4">
      <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/20 font-medium text-[10px] uppercase tracking-widest text-white/90 mb-2 bg-white/5 backdrop-blur-md">
        <span className="opacity-75">❖</span> INSIDE TRRIP
      </div>
      <h2 className="text-2xl md:text-4xl font-semibold text-white tracking-tight leading-tight drop-shadow-sm">
        Your portal. Their app. <span className="text-[#a7f3d0]">One connected trip.</span>
      </h2>
      <p className="text-white/80 text-base md:text-lg font-normal max-w-3xl mx-auto leading-relaxed pt-2">
        From the moment you add Trrip to a booking to the first dining pick your client makes on the
        ground, multiple post-booking suggestions flow seamlessly..
      </p>
    </div>
  );
};

export default SmartVouchersHeader;
